module.exports = __webpack_public_path__ + "img/arr_difficulty.153089b7.svg";